export const FONT_STACK = '"Roboto", "Inter", "Noto Sans Devanagari", sans-serif';
